.metrics {
    position: fixed;
    top: 20px;
    left: 20px;
    z-index: 1000;
    padding: 5px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #000000a6;
    pointer-events: none;
    transition: opacity 0.2s;

    &.transparent {
        opacity: 0.5;
    }
}

.lastFPS {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 10px;
    color: #000000a6;
}

.fps {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    height: 40px;
    gap: 1px;

    .fpsBar {
        background-color: black;
        width: 2px;
        max-height: 100%;
        flex: 0 0 2px;
    }
}

.loadMeter {
    margin-top: 5px;
    height: 4px;
    width: 100%;
    background-color: #00000012;
    padding: 1px 0;

    .loadMeterBar {
        height: 100%;
        background-color: #000000;
        transition: width 0.5s, background-color 0.5s;
    }
}

.processedPointsMeter {
    margin-top: 5px;
}

.processedPointsMeterText {
    font-size: 10px;
    color: #000000a6;
}

.hint {
    font-size: 10px;
    color: #000000a6;
    margin-top: 5px;

    a {
        pointer-events: auto;
    }
}

.temperatureMapContainer {
    margin-top: 5px;
}

.temperatureMap {
    position: static;

    transform-origin: left top;
    transform: scale(0.5);
}

/* Ensure links in metrics are clickable on mobile */
@media (max-width: 768px) {
    .hint a {
        pointer-events: auto;
    }
}